export default "__VITE_ASSET__BUoouT0V__"